import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Heading, Text } from '@frontend/design-system';

export const ScheduleRequestModalHeader = () => {
  const { t } = useTranslation('scheduleCalendarRequest');

  return (
    <header css={{ display: 'flex', flexDirection: 'column', gap: theme.spacing(1) }}>
      <Heading level={2}>{t('Review Appointment Request')}</Heading>
      <Text size='medium' color='subdued'>
        {t('Review and confirm the appointment request details below.')}
      </Text>
    </header>
  );
};
